import type { HTMLAttributes, Ref } from 'react'
import { cx } from '@/shared/lib'
import { BrandMark } from '@/shared/ui/BrandMark'
import s from './AuthBrand.module.css'

export type AuthBrandProps = {
  /** Словесная марка: «MERATECH». */
  name: string
  /** Подпись под маркой: «B2B PLATFORM». */
  kind: string
  ref?: Ref<HTMLDivElement>
} & Omit<HTMLAttributes<HTMLDivElement>, 'children'>

/**
 * Знак и словесная марка для слота `brand` каркаса `AuthShell` — лок-ап «Meratech B2B icon
 * system» для тёмной подложки: знак «Mi» цветом текста поверхности, начертание и подпись
 * текстом. Один на все экраны до входа: вход, заявка на доступ, выбор компании, приглашение.
 * Тексты — пропами, домена не знает. Знак декоративный: название уже звучит словесной маркой.
 */
export function AuthBrand({ name, kind, className, ref, ...rest }: AuthBrandProps) {
  return (
    <div {...rest} ref={ref} className={cx(s.root, className)}>
      <BrandMark size="xl" className={s.logo} />
      <span className={s.wordmark}>
        <span className={s.name}>{name}</span>
        <span className={s.kind}>{kind}</span>
      </span>
    </div>
  )
}
